import * as types from "./actionTypes";
import { successSnackbar, failureSnackbar } from "actions/snackbar/actions";

export const createNotification = equipment => {
  return (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore();
    const authorId = getState().firebase.auth.uid;

    const payload = {
      ...equipment,
      authorId: authorId,
      createdAt: new Date(),
      status: "pending",
    };

    return firestore
      .collection("notifications")
      .add(payload)
      .then(() => {
        dispatch({ type: types.NOTIFICATION_CREATE_SUCCESS });
        dispatch(successSnackbar("Notification created successfully"));
      })
      .catch(err => {
        dispatch({ type: types.NOTIFICATION_CREATE_ERROR }, err);
        dispatch(failureSnackbar("Notification create failure"));
      });
  };
};

export const updateNotification = (docId, equipment) => {
  return (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore();
    const authorId = getState().firebase.auth.uid;

    const payload = {
      ...equipment,
      modifiedBy: authorId,
      createdAt: new Date(),
    };

    return firestore
      .collection("notifications")
      .doc(docId)
      .update(payload)
      .then(() => {
        dispatch({ type: types.NOTIFICATION_UPDATE_SUCCESS });
        dispatch(successSnackbar("Notification updated successfully"));
      })
      .catch(err => {
        dispatch({ type: types.NOTIFICATION_UPDATE_ERROR }, err);
        dispatch(failureSnackbar("Notification update failure"));
      });
  };
};

export const deleteNotification = docId => {
  return (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore();

    return firestore
      .collection("notifications")
      .doc(docId)
      .delete()
      .then(() => {
        dispatch({ type: types.NOTIFICATION_DELETE_SUCCESS });
        dispatch(successSnackbar("Notification deleted successfully"));
      })
      .catch(err => {
        dispatch({ type: types.NOTIFICATION_DELETE_ERROR }, err);
        dispatch(failureSnackbar("Notification delete failure"));
      });
  };
};

export const queryCustomers = formvalues => {
  return (dispatch, getState, { getFirestore }) => {
    const { regionId, equipmentId, agreementId } = formvalues;

    const firestore = getFirestore();

    let query = firestore.collection("customers");

    if (regionId !== "*") {
      query = query.where("regionId", "==", regionId);
    }

    if (equipmentId !== "*") {
      query = query.where(`equipmentsIdsMap.${equipmentId}`, "==", true);
    }

    if (agreementId !== "*") {
      query = query.where(`agreementsIdsMap.${agreementId}`, "==", true);
    }

    return query.get().then(snapshot => {
      snapshot.forEach(doc => {
        console.log(doc.id, doc.data());
      });
    });
  };
};
